import React, { useState, useRef, useEffect } from "react";
import "./AIDemoV1.css";
import Message from "./MessageV1";
import useChat from "../auth/util/useChatV1";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { getUserSubInterestsAction } from "../actions/profileActions";
import { Alert, Box, Snackbar } from "@mui/material";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import { ArrowLeft } from "@mui/icons-material";
import fetchItemsNextToken from "../../graphql/fetchItemsNextToken";
import {
  listTblGradeMasters,
  searchCardItems,
  searchCards,
} from "../../graphql/queries";
import fetchSearchItemsNextToken from "../../graphql/fetchSearchItemsNextToken";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Legend,
  PointElement
);

const AIDemo = () => {
  const dispatch = useDispatch();
  const {
    generationConfig,
    setGenerationConfig,
    setModelType,
    sendMessage,
    messages,
    setMessages,
    systemPrompt,
    setSystemPrompt,
    initResponse,
    attemptDetails,
  } = useChat();

  const [openToast, setOpenToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [severityClass, setSeverityClass] = useState("success");

  const [newMessage, setNewMessage] = useState("");
  const [containerScrollDown, setContainerScrollDown] = useState("");
  const [forceUpdate, setForceUpdate] = useState(false);
  const historyRef = useRef(null);
  const profile = useSelector((state) => state.profileReducer);

  //XP system
  const [xp, setXp] = useState(0);
  const [level, setLevel] = useState(0);
  const [xpToNextLevel, setXpToNextLevel] = useState(100);
  const [xpBarWidth, setXpBarWidth] = useState(0);
  const [xpBarColor, setXpBarColor] = useState("green");
  const [penalty, setPenalty] = useState(0);
  const [remainingXP, setRemainingXP] = useState(10);
  const [attempt, setAttempt] = useState(0);
  const [selectedInterest, setSelectedInterest] = useState(1);

  //radar chart
  const dataArr = [4, 7, 3, 5, 4, 3];
  const dataBeforeArr = [4, 7, 3, 5, 4, 3];
  const [listOfXPs, setListOfXPs] = useState([]);
  const [listOfLevels, setListOfLevels] = useState([]);
  const options = {
    scale: {
      r: {
        max: 10,
        min: 0,
      },
    },
  };
  const chartRef = useRef(null);
  const [data, setData] = useState({ labels: [], datasets: [] });

  // AI
  const listOfPenalties = {
    off_topic: {
      penalty_amount: 0,
      penalty_reason: "Off Topic",
    },
    hint_used: {
      penalty_amount: 2,
      penalty_reason: "Hint Used",
    },
    answer_requested: {
      penalty_amount: 5,
      penalty_reason: "Answer Requested",
    },
    incorrect_answer: {
      penalty_amount: 1,
      penalty_reason: "Incorrect Answer",
    },
  };
  const [aiMode, setAIMode] = useState(true);
  const [tmpMessages, setTmpMessages] = useState([]);
  const teacherAI = `You are an engaging and interactive teacher, guiding students through various subjects with a structured and thought-provoking approach. Your teaching style follows a process designed to encourage curiosity, critical thinking, and problem-solving skills. Begin each session by presenting a real-life problem or scenario related to the subject matter. Encourage students to think independently and attempt an answer before revealing any explanations. If a student asks for the answer, do not provide it immediately. Instead, provide step-by-step process to reach the end, ensuring they understand the fundamental concepts behind the solution. Your goal is to foster deep comprehension rather than rote memorization. When a student provides a correct answer, acknowledge their effort with positive reinforcement and smoothly transition to the next problem or topic. If a student provides an incorrect answer, identify their mistake and help them recognize where they went wrong. 
Instead of simply correcting them, offer hints or alternative perspectives that encourage them to arrive at the right conclusion independently. Ensure that all problems and discussions are rooted in real-world applications, making learning more relatable and engaging. Whether teaching mathematics, science, history, or any other subject, use scenarios that students encounter in their daily lives. Keep the learning process dynamic, supportive, and interactive, nurturing curiosity and confidence in every student.Below are the details for the evaluation of response and also the topics and questions should be aligned with current CBSE curriculum(INDIA) but should be asked as real-world problems.,
AI-generated response detection,Analyze the user's response and determine the probability (0.0 - 1.0) that it was AI-generated. 
Evaluate AI-generated response detection based on (Strict evaluation):  Writing style consistency, Unusual fluency and coherence, Sudden shift in tone or vocabulary complexity, Repetitive structure or overuse of formal phrases, Comparison with previous responses (if available).
JSON structure provided below: 
 JSON Structure = { "reason_if_not_ai_generated": String // provide a 5 words reason ,"is_response_ai_generated": Number // Probability from 0.0 (human) to 1.0 (AI-generated) ,"off_topic": boolean, //A response is considered off-topic if it does not address the core intent of the question, introduces unrelated subjects, or ignores the given context. “is_correct”: boolean, // if user gives correct answer of the question then it should be true else false   “is_penalty”: boolean, // Whether a penalty was applied   “penalty_amount”: number, // XP deducted if penalty is applied   "penalty_reason": string, // Slug of the penalty from the list   "response": string // Natural response to the user's answer }
 penaltiesList = [ { "slug": "off_topic", "name": "Off Topic", "penalty_amount": 0 } // apply this penalty is the response is not in the context of the question, { "slug": "hint_used", "name": "Hint Used", "penalty_amount": 2 }// apply this penalty if user ask for hint or guide in any way, { "slug": "answer_requested", "name": "Answer Requested", "penalty_amount": 5 } // apply this penalty if user asks for answer directly in any way, { "slug": "incorrect_answer", "name": "Incorrect Answer", "penalty_amount": 1 }// apply this penalty if user gives incorrect answer]. 
 I want your response to follow the above json structure and nothing else. Use this JSON structure after the first interaction only. 
 Also you should striclty reply in JSON at all costs.`;

  const [viewRadar, setViewRadar] = useState(false);
  const [speed, setSpeed] = useState(1);

  const [gradeList, setGradeList] = useState([]);
  const [currentGrade, setCurrentGrade] = useState(null);

  const toggleSwitch = () => {
    setAIMode(!aiMode);
    setSpeed(-1);
    let _shifter = tmpMessages;
    setTmpMessages(messages);
    setMessages(_shifter);
    setSystemPrompt(!aiMode ? teacherAI : "Act as a helpful teacher");

    console.log(`Switch is ${!aiMode ? "ON" : "OFF"}`);
  };

  const resetSpeed = () => {
    setSpeed(1);
  };

  const handleCloseToast = () => {
    setOpenToast(false);
  };

  const handlePath = (path) => {
    console.log("path selected: ", path);

    let tmpMessages = [
      { role: "user", content: JSON.stringify(path), hidden: true },
      { role: "model", content: path.problem },
    ];
    setMessages(tmpMessages);
    setSelectedInterest(path.interest.toLowerCase());

    let excludedQ = JSON.parse(localStorage.getItem("excludedQ") || "[]");
    excludedQ.push(path.problem);
    localStorage.setItem("excludedQ", JSON.stringify(excludedQ));

    const previousXP = localStorage.getItem("xp_system") || null;
    if (!previousXP) {
      let xpSystem = {
        [path.interest.toLowerCase()]: {
          xp: 0,
          level: 0,
          xpToNextLevel: 100,
          attemptDetails: [],
          questionSolved: 0,
        },
      };
      localStorage.setItem("xp_system", JSON.stringify(xpSystem));
    } else {
      let _previousXP = JSON.parse(previousXP);
      if (!_previousXP[path.interest.toLowerCase()]) {
        _previousXP[path.interest.toLowerCase()] = {
          xp: 0,
          level: 0,
          xpToNextLevel: 100,
          attemptDetails: [],
          questionSolved: 0,
        };
        localStorage.setItem("xp_system", JSON.stringify(_previousXP));
      } else {
        let xpDetailsOfInterest = _previousXP[path.interest.toLowerCase()];
        setXp(xpDetailsOfInterest.xp);
        setLevel(xpDetailsOfInterest.level);
        setXpToNextLevel(xpDetailsOfInterest.xpToNextLevel);
      }
    }

    setForceUpdate((prev) => !prev);
  };

  const generateChart = () => {
    let previousXP = localStorage.getItem("xp_system");
    if (!previousXP) return;
    let _previousXP = JSON.parse(previousXP);

    let allLabels = profile.userSubInterests.map(
      (subInterest) => subInterest.subinterest.name
    );
    let labels = [];
    let _data = allLabels
      .map((label) => {
        if (
          _previousXP[label.toLowerCase()] &&
          _previousXP[label.toLowerCase()]?.xp > 0
        ) {
          labels.push(label);
          return _previousXP[label.toLowerCase()].xp;
        }
      })
      .filter((data) => data !== undefined);

    setData({
      labels: labels,
      datasets: [
        {
          label: "XP",
          data: _data,
          backgroundColor: "rgba(140, 199, 59, 0.2)",
          borderColor: "rgba(140, 199, 59, 1)",
          borderWidth: 1,
          pointBackgroundColor: "rgba(140, 199, 59, 1)",
          fill: false,
        },
      ],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newMessage.trim() !== "") {
      sendMessage(newMessage, false, aiMode);
      setNewMessage("");
    }
  };

  const updateXPBar = () => {
    setXpBarWidth((xp / xpToNextLevel) * 100);
    if (xp < 100) {
      setXpBarColor("red");
    } else {
      setXpBarColor("green");
    }
  };

  const getGrade = async (_userProfileDetailsID) => {
    let gradeDataQuery = await fetchItemsNextToken({
      query: listTblGradeMasters,
      variables: { filter: { status: { eq: 1 } } },
    });
    let getGradeData = gradeDataQuery.filter((item) => item._deleted !== true);

    if (getGradeData.length > 0) {
      let cardDataQuery = await fetchSearchItemsNextToken({
        query: searchCards,
        variables: {
          filter: {
            userprofiledetailsID: { eq: _userProfileDetailsID },
            title: { eq: "education" },
          },
        },
      });
      if (!(cardDataQuery.length > 0)) return null;

      let cardItemDataQuery = await fetchSearchItemsNextToken({
        query: searchCardItems,
        variables: {
          filter: { cardID: { eq: cardDataQuery[0].id }, status: { eq: 1 } },
          limit: 500,
        },
      });
      if (!(cardItemDataQuery.length > 0)) return null;

      let getCardItemData = cardItemDataQuery.sort((a, b) =>
        b.createdAt.localeCompare(a.createdAt)
      );

      let currentlyStudy = getCardItemData.filter(
        (item) => JSON.parse(item.newdata).currentlyStudying === true
      );
      if (currentlyStudy.length > 0) {
        let gradeData = JSON.parse(currentlyStudy[0].newdata);
        // let response = await fetchGrade(gradeData.endGrade);
        let gradeListData = getGradeData.filter(
          (item) => item.id == gradeData.endGrade
        );
        console.log("current grade (current): ", gradeListData[0].grade_name);
        setCurrentGrade(gradeListData[0].grade_name);
      } else {
        let gradeData = JSON.parse(getCardItemData[0].newdata);
        // let response = await fetchGrade(gradeData.endGrade);
        let gradeListData = getGradeData.filter(
          (item) => item.id == gradeData.endGrade
        );
        console.log("current grade: ", gradeListData);
        setCurrentGrade(gradeListData[0].grade_name);
      }
      setGradeList(getGradeData);
    }
  };

  useEffect(() => {
    if (historyRef.current) {
      historyRef.current.scrollTop = historyRef?.current?.scrollHeight;
    }
  }, [containerScrollDown]);

  useEffect(() => {
    if (profile.userSubInterests && currentGrade) {
      let subInterests = profile.userSubInterests.map(
        (subInterest) => subInterest.subinterest.name
      );
      let excludedQ = localStorage.getItem("excludedQ") || "";
      // let initialPrompt = `I am interested in ${subInterests.join(
      //   ", "
      // )}.I am currently studying in 6th grade. Give me  problems that I can solve for each of these interests in an Array giving you the schema below. The output should be only the array and nothing else.
      // example of problem statement for Math interest of grade 3: "Question = { "interest": "Math", "problem": "Today let's learn about BODMAS rule, What is the value of 2+2(9+1)/3", "difficulty": "Easy" }"
      // Question = { "interest": "Interest Name", "problem": "Problem Statement", "difficulty": "Difficulty Level" }

      // for mathematics interests please generate questions in cbse style not like real-world problem using below topics. These are CBSE grade 6 india topics:
      //  {
      //   "Knowing our Numbers": [
      //     "Comparing and Ordering 4-Digit Numbers",
      //     "Estimation",
      //     "Large Numbers",
      //     "Large Numbers in Practice",
      //     "Roman Numerals"
      //   ],
      //   "Whole Numbers": [
      //     "Identities and Special Properties of Whole Numbers",
      //     "Introduction to Whole Numbers",
      //     "Patterns in Whole Numbers",
      //     "Properties of Whole Numbers"
      //   ],
      //   "Playing with Numbers": [
      //     "Applications of HCF and LCM",
      //     "Divisibility Rules",
      //     "Factors and Multiples",
      //     "Highest Common Factor",
      //     "Lowest Common Multiple",
      //     "Prime and Composite Numbers",
      //     "Prime Factorisation"
      //   ],
      //   "Basic Geometrical Ideas": [
      //     "Basic Geometrical Ideas",
      //     "Circles",
      //     "Curves and Their Types"
      //   ],
      //   "Understanding Elementary Shapes": [
      //     "Angles",
      //     "Classification of Triangles",
      //     "Lines",
      //     "Quadrilaterals and Other Polygons",
      //     "Three Dimensional Shapes"
      //   ],
      //   "Integers": [
      //     "Addition of Integers",
      //     "Introduction to Integers",
      //     "Subtraction of Integers"
      //   ],
      //   "Fractions": [
      //     "Addition and Subtraction of Fractions",
      //     "Conversion of Fractions",
      //     "Equivalent Fractions",
      //     "Like and Unlike Fractions",
      //     "Types of Fractions and Their Representation"
      //   ],
      //   "Decimals": [
      //     "Addition and Subtraction of Decimals",
      //     "Comparison and Uses of Decimals",
      //     "Decimals: Tenths and Hundredths"
      //   ],
      //   "Data Handling": [
      //     "Bar Graphs",
      //     "Collecting and Organising Data",
      //     "Pictographs"
      //   ],
      //   "Mensuration": [
      //     "Area of Regular and Irregular Shapes",
      //     "Perimeter of Regular and Irregular Shapes"
      //   ],
      //   "Algebra": [
      //     "Algebraic Expressions",
      //     "Introduction to Algebra",
      //     "Introduction to Algebraic Equations"
      //   ],
      //   "Ratio and Proportion": [
      //     "Proportion",
      //     "Ratio",
      //     "Unitary Method"
      //   ],
      //   "Symmetry": [
      //     "Line Symmetry and Reflection Symmetry",
      //     "Symmetrical and Asymmetrical Figures"
      //   ],
      //   "Practical Geometry": [
      //     "Construction of a Circle",
      //     "Construction of a Line Segment",
      //     "Construction of Angles and their Bisectors",
      //     "Construction of Angles of Special Measures"
      //   ]
      // }

      // frame the question such that it can be answered in text format. Also,
      // exclude the below questions:
      // ${excludedQ}`;

      let initialPrompt = `I am interested in ${subInterests
        // .slice(0, 6)
        .join(
          ", "
        )}. I am currently studying in ${currentGrade} grade. Give me (now) problems that I can solve for each of these interests in an Array giving you the schema below. for this output give me json and no other text at all. Questions should align with CBSE curriculum
        JSON structure = { "interest": "Interest Name", "problem": "Problem Statement", "difficulty": "Difficulty Level" }
        Use only above JSON structure for this one output no other json structure. don't use system prompt json structure for this reponse
        example: [ { "interest": "Robotics", "problem": "Design a simple robotic arm using a pulley mechanism and explain how forces act on different parts.", "difficulty": "Medium" }, { "interest": "Physics", "problem": "A ball is thrown vertically upwards with a speed of 20 m/s. Calculate the maximum height it reaches and the time taken to reach there. (Take g = 9.8 m/s²)", "difficulty": "Medium" }, { "interest": "Mathematics", "problem": "Find the value of x if the sum of the first x natural numbers is 210.", "difficulty": "Medium" }, { "interest": "Chemistry", "problem": "Identify the type of chemical reaction: When magnesium ribbon burns in oxygen, it forms magnesium oxide.", "difficulty": "Easy" } ]

      exclude the below questions:
      ${excludedQ}`;

      console.log("initialPrompt: ", initialPrompt);
      sendMessage(initialPrompt, true, aiMode);
      generateChart();
    } else {
      console.log(
        "profile.userSubInterests: ",
        profile.userSubInterests,
        currentGrade
      );
    }
  }, [profile.userSubInterests, currentGrade]);

  useEffect(() => {
    if (!attemptDetails) return;
    let currentAttempt = {
      attempt: attempt,
      penalty: penalty,
      remaningXP: remainingXP,
    };
    const _attemptDetails = attemptDetails;

    if (_attemptDetails?.off_topic) {
      setToastMsg("You are off topic. Please stay on topic.");
      setSeverityClass("warning");
      setOpenToast(true);
    }

    if (_attemptDetails?.is_penalty) {
      let _penalty = listOfPenalties[_attemptDetails?.penalty_reason];
      if (_penalty) {
        currentAttempt.penalty =
          currentAttempt.penalty + _penalty.penalty_amount;
        currentAttempt.remaningXP =
          currentAttempt.remaningXP - _penalty.penalty_amount;
        currentAttempt.attempt = currentAttempt.attempt + 1;
        setToastMsg(
          `You have been penalized with ${_penalty.penalty_amount} XP for ${_penalty.penalty_reason}`
        );
        setSeverityClass("error");
        setOpenToast(true);
      }
      let isFailed = currentAttempt.remaningXP <= 0;
      if (isFailed) {
        setToastMsg(
          `You have failed to answer the question. Please try again.`
        );
        setSeverityClass("error");
        setOpenToast(true);
        setRemainingXP(10);
        setPenalty(0);
        setAttempt(0);
        return;
      }
    }

    if (_attemptDetails?.is_correct) {
      setToastMsg(
        `You have answered correctly. You have earned ${remainingXP} XP`
      );
      setSeverityClass("success");
      setOpenToast(true);

      currentAttempt.attempt = currentAttempt.attempt + 1;
      let previousXP = localStorage.getItem("xp_system");
      let _previousXP = JSON.parse(previousXP);
      let xpDetailsOfInterest = _previousXP[selectedInterest];
      xpDetailsOfInterest.xp = xpDetailsOfInterest.xp + remainingXP;
      xpDetailsOfInterest.questionSolved =
        xpDetailsOfInterest.questionSolved + 1;
      if (xpDetailsOfInterest.xp >= xpDetailsOfInterest.xpToNextLevel) {
        xpDetailsOfInterest.level = xpDetailsOfInterest.level + 1;
        xpDetailsOfInterest.xpToNextLevel =
          xpDetailsOfInterest.xpToNextLevel * 2;
      }
      xpDetailsOfInterest.attemptDetails = [
        ...xpDetailsOfInterest.attemptDetails,
        currentAttempt,
      ];
      console.log("xpDetailsOfInterest: ", xpDetailsOfInterest);

      localStorage.setItem("xp_system", JSON.stringify(_previousXP));
      setRemainingXP(10);
      setXp((previousXP) => previousXP + 10);
      setPenalty(0);
      setAttempt(0);
      generateChart();
      return;
    }

    setRemainingXP(currentAttempt.remaningXP);
    setPenalty(currentAttempt.penalty);
    setAttempt(currentAttempt.attempt);
  }, [attemptDetails]);

  useEffect(() => {
    if (historyRef.current) {
      historyRef.current.scrollTo({
        top: historyRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [containerScrollDown]);

  useEffect(() => {
    dispatch(getUserSubInterestsAction(localStorage.getItem("userDetailsID")));
    getGrade(localStorage.getItem("userDetailsID"));
  }, []);

  useEffect(() => {
    console.log("check speed", speed);
  }, [speed]);

  return (
    <div className="ai-demo-wrapper">
      <Header />
      <Snackbar
        open={openToast}
        autoHideDuration={3500}
        onClose={handleCloseToast}
      >
        <Alert
          variant="filled"
          onClose={handleCloseToast}
          severity={severityClass}
          sx={{ width: "100%" }}
        >
          {toastMsg}
        </Alert>
      </Snackbar>

      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "90vh",
          overflow: "hidden",
        }}
      >
        <div
          ref={historyRef}
          className="chat-container"
          style={{
            background: aiMode ? "#D9E7E8" : "#ffffff",
            width: viewRadar ? "60%" : "100%",
          }}
        >
          <div
            className="title"
            style={{
              width: "max-content",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              padding: "0.5rem",
              paddingLeft: "10px",
              margin: "20px 0",
            }}
          >
            <h3
              style={{
                color: aiMode ? "#04a5a6" : "grey",
                fontSize: "1.8rem",
                fontWeight: "600",
              }}
            >
              {aiMode ? "Teacher " : "General "}AI
            </h3>
            <div className="ai-switcher">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={aiMode}
                  onChange={toggleSwitch}
                />
                <span className="slider"></span>
              </label>
            </div>
            <div
              className="radar-toggle"
              style={{
                position: "absolute",
                top: "5%",
                right: "0",
                width: "40px",
                height: "40px",
                transform: `translateX(${viewRadar ? "110%" : "0"})`,
                transition: "all 0.2s",
                background: "#ffffff",
                borderRadius: `${viewRadar ? "0 50% 50% 0" : "50% 0 0 50%"}`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 99,
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              }}
              onClick={() => setViewRadar(!viewRadar)}
            >
              <ArrowLeft
                style={{
                  transform: `rotate(${viewRadar ? "180deg" : "0deg"})`,
                  transition: "all 0.2s",
                  height: "3rem",
                  width: "auto",
                  color: "#04a5a6",
                }}
              />
            </div>
          </div>

          {initResponse && (
            <div className="path-selection-wrapper">
              <div className="path-selection">
                {initResponse.map((path) => {
                  return (
                    <div
                      className="path"
                      onClick={() => {
                        handlePath(path);
                      }}
                    >
                      <p className="path-header">{path.interest}</p>
                      {/* <p className="path-difficulty">{path.difficulty}</p> */}
                    </div>
                  );
                })}
              </div>
              {/* <div>{`selected interests : ${selectedInterest} | XP : ${xp} | Level : ${level} `}</div> */}
            </div>
          )}

          <div
            className="chat-wrapper"
            style={{
              display: `${messages?.length ? "block" : "flex"}`,
              alignItems: `${messages?.length ? "flex-start" : "center"}`,
              justifyContent: `${messages?.length ? "flex-start" : "center"}`,
            }}
          >
            <div className="input-and-config-container">
              {messages?.length ? (
                <div className="chat-history" key={forceUpdate}>
                  {messages
                    .filter((message) => !message?.hidden)
                    .map((message, index) => {
                      // index === messages.length - 2 && resetSpeed();
                      return (
                        <div
                          key={index}
                          className={`message message-${message.role}`}
                        >
                          <div className="message-header"></div>
                          <span className="content">
                            <Message
                              key={index}
                              text={message.content}
                              role={message.role}
                              speed={speed}
                              setContainerScrollDown={setContainerScrollDown}
                            />
                          </span>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    textAlign: "center",
                    fontSize: "1rem",
                    color: "#04a5a6",
                    width: "100%",
                  }}
                >
                  {aiMode
                    ? "Welcome to your AI Tutor! 🚀 I'm here to help you level up your skills by asking questions and guiding you toward the right answers. Select a skill from the list above, and let's get started! I'll challenge you with questions—if you get it right, we move forward. If not, don't worry! I'll guide you step by step to help you understand and master the concept. Ready to learn? Let's go! 🎯"
                    : "Hello! 🤖 I'm your AI assistant, here to help you with anything you need—whether it's answering questions, solving problems, or guiding you step by step. Just ask away, and let's explore together! 🚀"}
                  :
                </div>
              )}
            </div>
          </div>

          <div
            className="message-input"
            style={{
              left: `${viewRadar ? "-22%" : "0%"}`,
            }}
          >
            <div className="input-wrapper">
              <textarea
                type="text"
                placeholder="Enter your message"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
              />
              <div className="send-button-container">
                <button
                  className="send-button"
                  type="submit"
                  disabled={newMessage.trim() === ""}
                  onClick={handleSubmit}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: viewRadar ? "40%" : "0%",
            borderLeft: "3px solid rgb(145,145,145)",
            position: "relative",
            transition: "all 0.3s",
          }}
        >
          <Radar
            data={data}
            style={{ width: "100%", height: "100%", position: "relative" }}
            ref={chartRef}
            options={{
              events: ["click"],
              showTooltip: false,
              animation: {
                duration: 0,
                onComplete: function (context) {
                  var ctx = context.chart.ctx;
                  ctx.font = `bold 12px Arial`;
                  ctx.textAlign = "center";
                  ctx.textBaseline = "bottom";

                  const datasets = context.chart.getDatasetMeta(0);

                  context.chart._metasets.forEach(function (dataset) {
                    for (var i = 0; i < dataset.data.length; i++) {
                      var model = dataset.data[i];
                      ctx.fillText(
                        dataset.data[i]?.$context.raw,
                        model.x,
                        model.y - 5
                      );
                    }
                  });
                },
              },
              responsive: true,
              scales: {
                r: {
                  beginAtZero: true,
                  angleLines: {
                    display: true,
                  },
                  suggestedMin: 0,
                  suggestedMax: Math.max(...listOfXPs, ...listOfLevels) + 10, // Adjusts based on data range
                  ticks: {
                    callback: (value) => {
                      const levelIndex = [100, 200, 400, 800, 1600].indexOf(
                        value
                      );
                      return levelIndex !== -1
                        ? `Level ${levelIndex + 1}`
                        : `${value} XP`; // Show "Level X" only at thresholds
                    },
                    backdropColor: "transparent",
                  },
                },
              },
              plugins: {
                legend: {
                  position: "top",
                },
              },
            }}
          />
        </Box>
      </Box>
    </div>
  );
};
export default AIDemo;
